import { theme } from 'appCore';

export default {
  divider: {
    backgroundColor: theme.colors.divider,
    height: 1.5,
    width: '100%'
  }
};
